import React, { useRef, useEffect } from 'react';
import { Box, Flex, Image, Heading, Text, Stack, Button, Icon } from '@chakra-ui/react';
import { MdSupportAgent, MdPublic, MdVerified } from 'react-icons/md';
import WhyChooseUs_Sidepic from '../../assets/WhyChooseUs_Sidepic.webp';
import VanillaTilt from "vanilla-tilt";
import { useNavigate } from 'react-router-dom';

function WhyChooseUs() {
  const tiltRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (tiltRef.current) {
      VanillaTilt.init(tiltRef.current, {
        max: 10,
        speed: 50,
        glare: false,
        "max-glare": 0,
      });
    }

    return () => {
      if (tiltRef.current?.vanillaTilt) {
        tiltRef.current.vanillaTilt.destroy();
      }
    };
  }, []);
  return (
    <Box as="section" py="16" bg="customDarkBlue" id="about">
      <Flex maxW="7xl" mx="auto" flexWrap="wrap" align="center" px={{ base: 4, md: 8 }}>
        {/* Image Section */}
        <Flex flex="1" justify="center" mb={{ base: 8, lg: 0 }} ref={tiltRef}  data-aos="flip-left">
          <Image
            src={WhyChooseUs_Sidepic}
            alt="Dremotech Team"
            maxH="500px"
          />
        </Flex>

        {/* Text Section */}
        <Box flex="1" pl={{ lg: 10 }} >
          <Text fontSize="sm" color="blue.500" mb="2" textTransform="uppercase" fontWeight="bold"  data-aos="fade-up">
            Why Dremotech?
          </Text>
          <Heading as="h2" size="xl" mb="6">
            Why Businesses Choose <Text as="span" color="blue.500">Dremotech Solutions</Text>
          </Heading>
          <Text mb="8" color="gray.600">
            At Dremotech Solutions, we deliver forward-thinking digital solutions tailored for businesses worldwide.
            Our commitment to innovation, reliability, and customer support sets us apart as your trusted tech partner.
          </Text>

          <Stack spacing="6">
            <Flex align="start">
              <Icon as={MdVerified} boxSize={7} color="blue.500" mr="4" />
              <Box>
                <Heading as="h5" size="md" mb="1">Proven Expertise</Heading>
                <Text color="gray.600">
                  Years of industry experience and a portfolio of successful projects across diverse sectors.
                </Text>
              </Box>
            </Flex>

            <Flex align="start">
              <Icon as={MdPublic} boxSize={7} color="blue.500" mr="4" />
              <Box>
                <Heading as="h5" size="md" mb="1">Global Presence</Heading>
                <Text color="gray.600">
                  Serving clients worldwide with seamless digital solutions, from startups to enterprises.
                </Text>
              </Box>
            </Flex>

            <Flex align="start">
              <Icon as={MdSupportAgent} boxSize={7} color="blue.500" mr="4" />
              <Box>
                <Heading as="h5" size="md" mb="1">24/7 Assistance</Heading>
                <Text color="gray.600">
                  Dedicated customer support around the clock to ensure your business runs without interruption.
                </Text>
              </Box>
            </Flex>
          </Stack>

          <Button mt="8" colorScheme="blue" size="lg" borderRadius="full"
            border="2px solid transparent"
            _hover={{
              bg: 'transparent',
              color: 'blue.300',
              border: '2px solid',
              borderColor: 'blue.400',
            }}
              onClick={() => navigate('/contact')}
              data-aos="zoom-in"
          >
            Let’s Work Together
          </Button>
        </Box>
      </Flex>
    </Box>
  );
}

export default WhyChooseUs;
